export default __webpack_public_path__ + "static/media/IMG_1686.84e731bb.jpg";